React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_team_item_component')

module.exports = class extends React.Component
  render: t.renderable ->
    { item } = @props
    { name, logoHash, displayName, activeMemberCount, deactivatedMemberCount, boards } = item

    t.div '.dashboard-list-item',  ->
      t.div '.member', ->
        t.a {
          href: "/#{ name }"
          title: name
        }, ->
          if logoHash
            t.img '.member-avatar', src: [logoDomain, logoHash, '30.png'].join('/')
          else
            t.span '.team-of-member-image.icon-lg.icon-organization'

      t.a {
        href: "/#{ name }"
        title: name
      }, ->
        t.div '.details', ->
          t.p '.name-line.name-without-details', ->
            t.span '.full-name', ->
              t.text displayName

      t.div '.options', ->
        t.p '.option.status.quiet', ->
          t.format 'members', { activeCount: activeMemberCount, deactivatedCount: deactivatedMemberCount }



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/team-item-component.coffee